import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined, SafetyCertificateOutlined, DashboardOutlined, TeamOutlined, FileTextOutlined } from '@ant-design/icons';
import './admin.css';

export default function AdminLogin() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: { account: string; password: string }) => {
    setLoading(true);
    try {
      const resp = await fetch('/api/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      }).then(r => r.json());

      if (resp && resp.ok) {
        localStorage.setItem('admin_token', resp.token);
        localStorage.setItem('admin_user', JSON.stringify(resp.user));
        message.success('登录成功');
        navigate('/admin/dashboard');
      } else {
        message.error(resp?.error || '登录失败');
      }
    } catch (err) {
      message.error('登录失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      {/* 左侧品牌区域 */}
      <div className="admin-login-left">
        <div className="admin-login-brand">
          <div className="admin-login-brand-icon">
            
          </div>
          <h1>德润慧通管理后台</h1>
          <p>专业的招标采购管理平台</p>
        </div>
        
        <div className="admin-login-features">
          <div className="admin-login-feature">
            <div className="admin-login-feature-icon">
              <DashboardOutlined />
            </div>
            <span>数据可视化仪表盘</span>
          </div>
          <div className="admin-login-feature">
            <div className="admin-login-feature-icon">
              <TeamOutlined />
            </div>
            <span>高效的用户管理系统</span>
          </div>
          <div className="admin-login-feature">
            <div className="admin-login-feature-icon">
              <FileTextOutlined />
            </div>
            <span>完善的标书档案管理</span>
          </div>
        </div>
      </div>
      
      {/* 右侧登录表单 */}
      <div className="admin-login-right">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <h1>管理后台</h1>
            <p>请使用管理员账号登录</p>
          </div>
          
          <Form
            name="admin-login"
            onFinish={onFinish}
            autoComplete="off"
            size="large"
            style={{ marginTop: 24 }}
          >
            <Form.Item
              name="account"
              rules={[{ required: true, message: '请输入账号' }]}
            >
              <Input
                prefix={<UserOutlined style={{ color: '#9ca3af' }} />}
                placeholder="账号"
                style={{ 
                  height: 52, 
                  borderRadius: 12,
                  fontSize: 15
                }}
              />
            </Form.Item>
            
            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码' }]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: '#9ca3af' }} />}
                placeholder="密码"
                style={{ 
                  height: 52, 
                  borderRadius: 12,
                  fontSize: 15
                }}
              />
            </Form.Item>
            
            <Form.Item style={{ marginTop: 32 }}>
              <Button
                type="primary"
                htmlType="submit"
                block
                loading={loading}
                style={{
                  height: 52,
                  borderRadius: 12,
                  fontSize: 16,
                  fontWeight: 600,
                  background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                  border: 'none',
                  boxShadow: '0 4px 15px rgba(59, 130, 246, 0.4)'
                }}
              >
                {loading ? '登录中...' : '登 录'}
              </Button>
            </Form.Item>
          </Form>
          
          <div style={{ textAlign: 'center', marginTop: 24, color: '#9ca3af', fontSize: 13 }}>
            © {new Date().getFullYear()} 德润慧通工程项目管理(四川)有限公司
          </div>
        </div>
      </div>
    </div>
  );
}
